<p-dialog
  [(visible)]="showModal"
  [modal]="true"
  [closable]="true"
  [dismissableMask]="false"
  [closeOnEscape]="false"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '24rem', maxWidth: 'calc(100vw - 2rem)' }"
>
  <ng-template pTemplate="header">
    <div class="flex justify-between items-center w-full">
      <span class="text-2xl font-semibold text-primary">{{ 'SESSION_TIMEOUT.TITLE' | translate }}</span>
    </div>
  </ng-template>

  <ng-template pTemplate="body">
    <div class="p-4 text-gray-700">
      <p> {{ 'SESSION_TIMEOUT.MESSAGE' | translate:{ seconds: countdown() } }}</p>
    </div>
  </ng-template>

  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-3">
      <button class="border border-gray-300 px-4 py-2 rounded-sm"
        pButton
        type="button"
        severity="secondary"
        label="{{'SESSION_TIMEOUT.LOGOUT_BUTTON' | translate}}"
        (click)="logoutNow()"
      >
      </button>
      <button class="bg-primary text-white px-4 py-2 rounded-sm"
        pButton
        type="button"
        label="{{'SESSION_TIMEOUT.CONTINUE_BUTTON' | translate}}"
        (click)="continueNow()"
      >
      </button>
    </div>
  </ng-template>

</p-dialog>